var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"upload-container"},[_c('el-button',{style:({ background: _vm.color, borderColor: _vm.color }),attrs:{"icon":"el-icon-upload","size":"mini","type":"primary"},on:{"click":function($event){return _vm.modalPicTap('2')}}},[_vm._v("上传图片")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }